/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */
import * as Msdyn365 from "@msdyn365-commerce/core";
import axios from "axios";

/**a
 * britaxGetAtpDate Input Action
 */
export interface IAtpPayload {
  productReferenceNumber: number;
  quantity: number;
}

export class BritaxGetAtpDateInput implements Msdyn365.IActionInput {
  // TODO: Construct the input needed to run the action
  public atpPayload: IAtpPayload[] | [];
  public token: string;

  constructor(atpPayload: IAtpPayload[] | [], token: string) {
    this.atpPayload = atpPayload;
    this.token = token;
  }

  // TODO: Determine if the results of this get action should cache the results and if so provide
  // a cache object type and an appropriate cache key
  public getCacheKey = () => `getAtpDate`;
  public getCacheObjectType = () => "getAtpDate";
  public dataCacheType = (): Msdyn365.CacheType => "none";
}

/**
 * TODO: Use this function to create the input required to make the action call
 */
const createBritaxGetAtpDateInput = (
  args: Msdyn365.ICreateActionContext
): Msdyn365.IActionInput => {
  return new BritaxGetAtpDateInput([], "");
};

/**
 * TODO: Use this function to call your action and process the results as needed
 */
export async function getAtpDateAction(
  input: BritaxGetAtpDateInput,
  ctx: Msdyn365.IActionContext
): Promise<any> {
  const processName = ctx.requestContext.app.config.rcvAtpApiProcessName;
  const res = await axios(ctx.requestContext.app.config.rcvAtpApiUrl, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${input.token}`,
    },
    data: {
      ProcessName: processName,
      ATPList: input.atpPayload,
    },
  });
  return res.data;
}

export default Msdyn365.createObservableDataAction({
  action: <Msdyn365.IAction<any>>getAtpDateAction,
  // TODO: Give your data action a unique id
  id: "BritaxGetAtpToken",
  input: createBritaxGetAtpDateInput,
  // TODO: Uncomment the below line if this is a meant to be a batched data action
  // isBatched: true
});
